import React from 'react';
import { Layout } from 'antd';
import { TrackedWebsites } from '../../containers';
import BacklinksForm from '../BacklinksForm';
import Backlinks from '../Backlinks';

/**
 * The actual page of the backlinks route. Will display an input form and the backlinks data
 * under the tracked websites tab
 * (an overview and the data tabs). Actual backlinks data is inside the Backlinks component
 * @returns React element
 */
export default function BacklinksPage() {
	return (
		<Layout.Content className="general-layout-content">
			<BacklinksForm />
			<TrackedWebsites tabContent={<Backlinks />} showDomains destroyInactiveTabs={true} />
		</Layout.Content>
	);
}
